
const errorInterceptor = (axiosInstance) => {

    axiosInstance.interceptors.response.use((response) => {
        return response;
    },
     error => {
      console.log(error);
    //  const status = error?.response?.status;
      let msg = error?.response?.data?.message;
      if (msg === undefined) {
        msg = error?.response?.data?.message;
      }
      if (msg === undefined) {
        msg = error?.response?.data;
      }
    
      return Promise.reject(error);
    }
  );
};
export default errorInterceptor;